import deliveryZipcodeService from "./deliveryZipcodeService";
import cookie from "./storageManager/methods/cookie";
import local from "./storageManager/methods/local";
import localizerService from "./localizerService";
import storeService from "./storeService";
import userService from "./userService";
import { EVENTS, STORAGE_IDENTIFIERS, THD_LOCALIZER } from "./common/constants";

export const initializeUserSession = async () => {
  const hasSession = userService.status.getSessionToPreventUserInStoreCall();
  if (!hasSession && !userService.status.isRequestFromConsumerApp()) {
    userService.operations.setSessionToPreventUserInStoreCall();
    try {
      const position = await localizerService.getCoords();
      local.put({
        key: STORAGE_IDENTIFIERS.AUTHORIZED_GEOLOCATION,
        value: 1,
      });
      const storeNumber =
        await localizerService.checkForStoreNumberForUserInsideStore(position);
      userService.operations.setStoreNumberIfUserIsInsideStore(storeNumber);
    } catch (_) {
      local.put({
        key: STORAGE_IDENTIFIERS.AUTHORIZED_GEOLOCATION,
        value: 0,
      });
    }
  }
};

initializeUserSession();

const Localizer = {
  event: EVENTS,
  status: userService.status,
  __getTHDLocalizer: () => cookie.get(THD_LOCALIZER),
  checkForStoreNumberForUserInsideStore:
    localizerService.checkForStoreNumberForUserInsideStore,
  getDeliveryZipcodeDetails: deliveryZipcodeService.getDeliveryZipcodeDetails,
  getDeliveryZipcodeType: deliveryZipcodeService.getDeliveryZipcodeType,
  getLocalizedStore: storeService.getStore,
  getUserStore: storeService.getUserStore,
  localize: localizerService.localize,
  localizeFuzzy: localizerService.localizeFuzzy,
  off: localizerService.off,
  on: localizerService.on,
  updateDeliveryZipcodeDetails: localizerService.updateDeliveryZipcodeDetails,
  updateDeliveryZipcodeDetailsNoEvent:
    localizerService.updateDeliveryZipcodeDetailsNoEvent,
  validateUSZipcode: deliveryZipcodeService.validateUSZipcode,
  validateSoftLink: localizerService.validateSoftLink,
};

export default Localizer;
